import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberCodebug = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M17.482 1.145a1 1 0 0 1 1.373.336l8.078 13.325a1 1 0 1 1-1.71 1.036L17.145 2.518a1 1 0 0 1 .337-1.373m29.075 0a1 1 0 0 1 .337 1.373l-8.078 13.324a1 1 0 1 1-1.71-1.037l8.078-13.324a1 1 0 0 1 1.373-.336M1 40a1 1 0 0 1 1-1h11.986a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m47.986 0a1 1 0 0 1 1-1H62a1 1 0 1 1 0 2H49.986a1 1 0 0 1-1-1m-29.87 13.109a1 1 0 0 1-.743 1.203c-1.959.464-3.63 1.907-4.939 3.596-1.3 1.677-2.149 3.478-2.493 4.432a1 1 0 1 1-1.882-.68c.406-1.122 1.35-3.113 2.794-4.977 1.436-1.853 3.462-3.703 6.06-4.317a1 1 0 0 1 1.203.743m25.77 0a1 1 0 0 1 1.203-.743c2.6.614 4.625 2.464 6.06 4.317 1.445 1.864 2.387 3.855 2.792 4.978a1 1 0 1 1-1.882.678c-.343-.953-1.192-2.754-2.49-4.431-1.31-1.69-2.98-3.133-4.94-3.596a1 1 0 0 1-.743-1.203",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M20.058 21.63c-3.115 4.154-5.072 9.938-5.072 16.37s1.957 12.217 5.072 16.37S27.401 61 31.986 61s8.813-2.476 11.928-6.63c3.115-4.153 5.072-9.938 5.072-16.37s-1.957-12.216-5.072-16.37S36.57 15 31.986 15s-8.813 2.476-11.928 6.63m-1.6-1.2c3.4-4.533 8.172-7.43 13.528-7.43s10.128 2.897 13.528 7.43S50.986 31.176 50.986 38s-2.073 13.038-5.472 17.57c-3.4 4.533-8.172 7.43-13.528 7.43s-10.128-2.897-13.528-7.43S12.986 44.824 12.986 38s2.073-13.038 5.472-17.57",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M9.612 15.079a1 1 0 0 1 1.31.533C14.139 23.244 22.056 29 32 29h.012a22.84 22.84 0 0 0 21.077-13.413 1 1 0 1 1 1.822.826A24.84 24.84 0 0 1 33 30.99V62a1 1 0 1 1-2 0V30.982c-10.276-.373-18.5-6.475-21.921-14.593a1 1 0 0 1 .533-1.31",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberCodebug;
